import { render, staticRenderFns } from "./bigTitle.vue?vue&type=template&id=6b2c8f6a&scoped=true"
import script from "./bigTitle.vue?vue&type=script&lang=js"
export * from "./bigTitle.vue?vue&type=script&lang=js"
import style0 from "./bigTitle.vue?vue&type=style&index=0&id=6b2c8f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2c8f6a",
  null
  
)

export default component.exports